<template>
  <div>
    <div v-if="!loading">
      <router-view />
    </div>
    <div v-else>
      <div class="container max-w-screen-md pt-20 space-y-12" element-loading-background="rgba(255, 255, 255, 0.05)">
        <content-loader primaryColor="#f8efe6" secondaryColor="#f8efe655" class="w-full" :speed="1.5" :primaryOpacity="0.9" :secondaryOpacity="0.9" />
        <content-loader
          primaryColor="#f8efe6"
          secondaryColor="#f8efe655"
          class="w-full"
          :speed="1.5"
          :primaryOpacity="0.65"
          :secondaryOpacity="0.65"
        />
        <content-loader primaryColor="#f8efe6" secondaryColor="#f8efe655" class="w-full" :speed="2.5" :primaryOpacity="0.5" :secondaryOpacity="0.5" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as actions from '@/store/action-types';
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'Admin',
  components: {
    ContentLoader,
  },
  data() {
    return {
      loading: true,
    };
  },
  async created() {
    if (this.$store.state.asOrg) {
      await this.$store.dispatch(actions.SWITCH_ORG, null);
    }
    this.loading = false;
  },
};
</script>
